import { Component, OnInit } from '@angular/core';
import { IHRBMicroUiConfig } from '../shared/interfaces/hrblock-micro-ui-config-interface';
import { microApps } from '../shared/services/config';
import { microUI } from '../shared/constants';
import { AnalyticsService } from '../shared/services/analytics.service';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  styleUrls: ['./billing-page.component.scss']
})
export class BillingPageComponent implements OnInit {

  public BillingAndPayment: IHRBMicroUiConfig = microApps[microUI.billingAndPayment];

  constructor(private analyticsService : AnalyticsService) {
  }

  ngOnInit() {
    this.analyticsService.cartPageLoad("billing and payment information");
  }

}
